import React from 'react';
import { Row, Col, Table, Button, Select } from 'antd';
import { DownloadOutlined, SortAscendingOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import '../affiliate-management.scss';
import { Link } from 'react-router-dom';
import Header from '@sharedComponent/header/header';
import AppLoader from '@sharedComponent/loaders/app-loader';
import { affiliateUsageFilter } from '@constants';

const { Option } = Select;

export const AffiliateManagementPresentational = ({ affiliateManagementData = [], affiliateManagementLoading, columns, handleFilterChange }) => {
	return (
		<Row className="affiliate_management_report_container">
			<Col xl={24}>
				<Header title="Affiliate Management" hideAddAffiliate />
			</Col>
			<Row className="chart_area" style={{ paddingTop: 0 }}>
				<Col xl={24} style={{ width: '100%' }}>
					<Col className="chart_container" style={{ width: '100%' }}>
						<Row className="chart_header">
							<Col xl={8}>
								<Link to="/add-affiliate">
									<Button type="primary" style={{ borderRadius: 5 }} icon={<UsergroupAddOutlined />} size={'middle'}>
										Add Affiliate
									</Button>
								</Link>
							</Col>
							<Col xl={16} className="chart_header_right_area">
								<Row>
									<Col className="actions">
										<Button style={{ borderRadius: 5 }} type="primary" icon={<DownloadOutlined />} size={'middle'}>
											Export to CSV
										</Button>
									</Col>
									<Col className="actions">
										<Select
											onChange={handleFilterChange}
											style={{ borderRadius: 5 }}
											defaultValue={'All'}
											className="filter_area"
											style={{ width: 120 }}>
											{affiliateUsageFilter.map((filter, i) => (
												<Option value={filter.value}>{filter.label}</Option>
											))}
										</Select>
									</Col>
									{/* <Col className="actions">
										<Button style={{ borderRadius: 5 }} type="default" icon={<SortAscendingOutlined />} size={'middle'}>
											Sort
										</Button>
									</Col> */}
								</Row>
							</Col>
							<Col xl={24} className="aff_usage_table_container ">
								{affiliateManagementLoading ? (
									<Col style={{ minHeight: 400, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
										<AppLoader width="5%" height="5%" />
									</Col>
								) : (
									<Table
										pagination={{
											position: ['bottomCenter', 'bottomCenter'],
											defaultPageSize: 5,
											showSizeChanger: true,
											pageSizeOptions: ['5', '10'],
										}}
										dataSource={affiliateManagementData}
										columns={columns}
									/>
								)}
							</Col>
						</Row>
					</Col>
				</Col>
			</Row>
		</Row>
	);
};
